import { render } from "./Wordstat3.vue?vue&type=template&id=3f7730a5"
import script from "./Wordstat3.vue?vue&type=script&lang=js"
export * from "./Wordstat3.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__